import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';
import { motion, useInView } from 'framer-motion';
import erledixLogo from '../../assets/erledix-logo-bg-trimmed.png';

export const HeroSection = () => {
	const items = [
		{
			problem: 'Ständige Diskussionen über unerledigte Aufgaben',
			solution:
				'Mit Erledix ist klar geregelt, wer was wann erledigt – Streit gehört der Vergangenheit an.',
		},
		{
			problem: 'Unklare Zuständigkeiten und vergessene To-dos',
			solution:
				'Dank digitaler Aufgabenübersicht weiß jedes Familienmitglied, was zu tun ist.',
		},
		{
			problem: 'Geringe Motivation bei Kindern zu regelmäßigen Abläufen',
			solution:
				'Erledix belohnt erledigte Aufgaben mit einem motivierenden Punktesystem, damit Aufgaben selbstständig erledigt werden.',
		},
	];

	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-50px' });

	return (
		<header className='App-header'>
			<motion.div
				ref={ref}
				className='Hero-section'
				initial={{ opacity: 0, y: 30 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ duration: 0.6, ease: 'easeOut' }}
			>
				<img src={erledixLogo} className='App-logo' alt='Erledix logo' />
				<h1 className='Hero-title'>
					Weniger Streit, mehr erledigt –{' '}
					<span style={{ color: '#6C5CE7' }}>Erledix</span> bringt Ruhe in deinen
					Familienalltag.
				</h1>
				<div className='hero-problems-list'>
					{items.map((item, index) => (
						<motion.div
							className='hero-problem-item'
							key={index}
							initial={{ opacity: 0, y: 20 }}
							animate={isInView ? { opacity: 1, y: 0 } : {}}
							transition={{ delay: 0.1 + index * 0.1, duration: 0.4 }}
						>
							<h2 className='problem-title'>{item.problem}?</h2>
							<p className='solution-text'>{item.solution}</p>
						</motion.div>
					))}
				</div>
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={isInView ? { opacity: 1, y: 0 } : {}}
					transition={{ delay: 0.4, duration: 0.4 }}
				>
					<Link to='/beta-signup' className='cta-button'>
						Werde jetzt Teil der Erledix Community und trage zu weniger Stress im
						Familienalltag bei.
					</Link>
				</motion.div>
			</motion.div>
		</header>
	);
};
